import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import ProductRateCreateModal from 'src/pages/ProductRate/ProductRateCreateModal';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchProductRate,
  setDataSuccess,
  selectProductRate
} from 'src/features/staticDataSlice';
import { checkPermission } from 'src/utils/permission';

const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function ProductRateList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [productRateCreatePermission, setProductRateCreatePermission] = useState(false);

  const productRateData = useSelector(selectProductRate);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setProductRateCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('productRates', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchProductRate(productId).then(data =>
      dispatch(setDataSuccess({ dataType: 'productRate', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation logic if required

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-productRates" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-productRates"
          id="select-productRates"
          value={tableListDatas[index]?.productRates || ''}
          onChange={(event) => {
            handleChange('productRates', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {productRateData?.map((productRate) => (
            <MenuItem key={productRate.productName} value={productRate.productName}>
              {productRate.productName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              productRateCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Product Rate
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (productRateCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: productRateCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <ProductRateCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default ProductRateList;
